import * as React from 'react'

import { IResourceGroupPresentation } from '~/client/src/shared/resources/resourceLink'
import { cn } from '~/client/src/shared/utils/cn'

import { Checkbox } from '../shadcn-ui/checkbox'
import GroupHeader from './GroupHeader'
import GroupHeaderTrigger from './GroupHeaderTrigger'
import GroupIndent from './GroupIndent'

interface IResourceGroupHeaderSelection {
  checked: boolean
  indeterminate?: boolean
  disabled?: boolean
  onChange: () => void
  ariaLabel: string
}

interface IProps {
  label: string
  count?: number
  depth?: number
  isExpanded: boolean
  onToggle: () => void
  presentation?: IResourceGroupPresentation | null
  selection?: IResourceGroupHeaderSelection
  className?: string
}

export default function ResourceGroupHeader({
  label,
  count,
  depth = 0,
  isExpanded,
  onToggle,
  presentation,
  selection,
  className,
}: IProps): React.ReactElement {
  return (
    <GroupHeader
      role="group"
      aria-label={label}
      data-slot="resource-group-band"
      className={cn('tw:relative', className)}
    >
      {selection && (
        <Checkbox
          checked={selection.checked}
          indeterminate={selection.indeterminate}
          disabled={selection.disabled}
          onCheckedChange={() => selection.onChange()}
          aria-label={selection.ariaLabel}
        />
      )}
      <GroupHeaderTrigger
        expanded={isExpanded}
        onClick={onToggle}
        ariaLabel={label}
        leading={<GroupIndent depth={depth} />}
        labelIcon={presentation?.labelIcon}
        label={presentation?.label ?? label}
        count={typeof count === 'number' ? count : undefined}
      />
    </GroupHeader>
  )
}
